import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContextMenuElement } from '@m4u-angular/base/classes/BaseClasses';
import { BaseGridComponent } from '@m4u-angular/base/component/BaseGridComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState, CredentialsCheckerMetadata, CredentialExternalInfo, CredentialType, SystemCredentialInfo }
    from '@m4u-angular/base/entities/BaseEntities';
import { DateHelpers } from '@m4u-angular/core/helpers/DateHelpers';

@Component({
    providers: ServiceBagServices,
    selector: 'app-system-credentials-grid',
    templateUrl: './system-credentials-grid.component.html'
})
export class SystemCredentialsGridComponent extends BaseGridComponent<SystemCredentialInfo, BaseState>{
    @Input() IsSelectionMode: boolean = false;
    @Input() IsAllowPagination: boolean = true;
    @Input() CredentialTypes: CredentialType[];
    @Input() AdditionalInfoMetadata: CredentialsCheckerMetadata;
    @Output() OnSelectionChanged = new EventEmitter<CredentialExternalInfo[]>();
    @Output() OnRefresh = new EventEmitter<void>();

    constructor(A: ServiceBagService) {
        super(A, 'SystemCredentialsGridComponent', SystemCredentialInfo, BaseState);
    }

    protected override GetGridRowContextMenu(options?: any): ContextMenuElement[] {
        if(this.IsSelectionMode) {
            return [];
        }

        return [{
            text: this.RC('btnManageCredentials'),
            visible: true,
            onClick: () => this.OnManageCredentials(options)
        }, {
            text: this.RC('btnGoToLoginHistory'),
            visible: true,
            onClick: () => this.Navigate(['pages/general/credential-login-history'], { CredentialID: options.data.EntryID })
        }, {
            text: this.RC('btnGoToRequestsHistory'),
            visible: true,
            onClick: () => this.Navigate(['pages/general/requests-history'], { CredentialID: options.data.EntryID })
        }];
    }

    OnNavigate(e) {
        if (!this.IsSelectionMode && e?.data) {
            this.OnManageCredentials(e);
        }
    }

    OnGetLastUsedBeforeText(rowData): string {
        return rowData.LastUseDate ? DateHelpers.GetDateApproximate((rowData as SystemCredentialInfo).LastUseDate, false) : '';
    }

    GetCaption(rowData, captionField): string {
        return rowData[captionField];
    }

    OnManageCredentials(options: any) {
        const { Type, EntryID } = options.data;
        this.Navigate(['/pages/passwordmanage'], { CredentialID: EntryID, Type: Type });
    }

    OnGridSelectionChanged(event: any) {
        this.OnSelectionChanged.emit(this.grid.instance?.getSelectedRowsData());
    }

    OnToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            isCustom: true,
            options: {
                icon: 'refresh',
                onClick: () => {
                    this.OnRefresh.emit();
                }
            }
        });
    }
}
